import React, { useCallback, useState } from 'react'

import { type WidgetDTO } from '../../../../../model/Widget'

import {
  BusinessCardEditMode,
  type BusinessCardFormValues,
} from './edit/BusinessCardEditMode'
import { BusinessCardPreview } from './preview/BusinessCardPreview'

import './WidgetBusinessCard.scss'

interface WidgetBusinessCardProps {
  widget: WidgetDTO
  isEditable?: boolean
  onSave?: (values: Partial<WidgetDTO>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}

export const WidgetBusinessCard = ({
  widget,
  isEditable = false,
  onSave,
  onDelete,
  onCancel,
}: WidgetBusinessCardProps) => {
  const [isEditMode, setIsEditMode] = useState(false)

  const handleEdit = useCallback(() => {
    setIsEditMode(true)
  }, [])

  const handleCancel = useCallback(() => {
    setIsEditMode(false)
    onCancel?.()
  }, [onCancel])

  const handleSubmit = useCallback(
    async (values: BusinessCardFormValues) => {
      await onSave?.(values)
      setIsEditMode(false)
    },
    [onSave]
  )

  const handleDelete = useCallback(() => {
    onDelete?.()
  }, [onDelete])

  return isEditMode ? (
    <BusinessCardEditMode
      widget={widget}
      onSave={handleSubmit}
      onCancel={handleCancel}
    />
  ) : (
    <BusinessCardPreview
      widget={widget}
      isEditable={isEditable}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  )
}
